interface TimeSinceUpdateProps {
  updatedAt: Date;
}

export function TimeSinceUpdate({ updatedAt }: TimeSinceUpdateProps) {
  const seconds = Math.floor(
    (new Date().getTime() - new Date(updatedAt).getTime()) / 1000,
  );

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  let fullTime = `${remainingSeconds}s`;
  let compactTime = fullTime;
  if (hours > 0) {
    fullTime = `${hours}h ${minutes}m ${remainingSeconds}s`;
    compactTime = `${hours}h…`;
  } else if (minutes > 0) {
    fullTime = `${minutes}m ${remainingSeconds}s`;
    compactTime = `${minutes}m…`;
  }
  const isAbbreviated = compactTime !== fullTime;

  let colorClass = "";
  let emoji = "💚";
  if (seconds > 3600) {
    colorClass = "text-red-500";
    emoji = "❤️";
  } else if (seconds > 60) {
    colorClass = "text-yellow-500";
    emoji = "💛";
  }

  return (
    <p
      className="group/heartbeat relative w-auto min-w-0 overflow-visible text-xs"
      aria-label={`${fullTime} since last heartbeat`}
      title={`${fullTime} since the cluster agent last reported in`}
    >
      <span
        className={`${colorClass} inline-flex items-center whitespace-nowrap ${
          isAbbreviated ? "group-hover/heartbeat:invisible" : ""
        }`}
      >
        {emoji} {compactTime}
      </span>
      {isAbbreviated ? (
        <span className="invisible absolute -top-1 left-0 z-50 inline-flex items-center whitespace-nowrap rounded border border-gray-200 bg-white px-2 py-1 text-gray-900 shadow-md group-hover/heartbeat:visible">
          {emoji} {fullTime}
        </span>
      ) : null}
    </p>
  );
}
